import { createSelector } from 'reselect';

export const reviewsSelector = (state) => state.reviews;

export const totalPagesSelector = createSelector(
  reviewsSelector,
  (reviews) => reviews.total_pages,
);

export const totalReviewsSelector = createSelector(
  reviewsSelector,
  (reviews) => reviews.total,
);

export const entriesSelector = createSelector(
  reviewsSelector,
  (reviews) => reviews.entries,
);

export const currentPageSelector = createSelector(
  reviewsSelector,
  (reviews) => reviews.currentPage,
);

export const pageSelector = createSelector(
  reviewsSelector,
  (reviews) => reviews.page,
);

export const ratingSelector = createSelector(
  reviewsSelector,
  (reviews) => reviews.rating,
);

export const reviewsLoadingSelector = createSelector(
  reviewsSelector,
  (reviews) => reviews.loading,
);
